export default __webpack_public_path__ + "static/media/cp_geo_de.e5316ade.svg";